import { useNavigate } from "react-router-dom";
import { ChevronRight, ArrowLeft } from "lucide-react";

const AdminViewBreadcrumb = ({ viewerRole, fromTab, entityType, entityName, testId = "admin-view-breadcrumb" }) => {
  const navigate = useNavigate();

  const rootLabel = viewerRole === "admin" ? "Admin Control Board" : "Coach Dashboard";
  const rootPath = viewerRole === "admin" ? "/admin" : "/coach";

  const tabLabel =
    entityType === "client" ? "Clients"
    : entityType === "expert" ? "Experts"
    : entityType === "coach" ? "Coaches"
    : fromTab || "Dashboard";

  const handleRootClick = () => navigate(rootPath);
  const handleTabClick = () => navigate(rootPath);

  return (
    <div className="fixed top-0 w-full z-[60] bg-cosmic-deep/95 backdrop-blur-md border-b border-divine-gold/20" data-testid={testId}>
      <div className="max-w-7xl mx-auto px-6 py-2.5 flex items-center gap-3">
        <button
          onClick={handleRootClick}
          className="p-1.5 rounded-lg hover:bg-divine-gold/10 transition-colors text-divine-gold/70 hover:text-divine-gold"
          data-testid="breadcrumb-back-btn"
          aria-label="Go back"
        >
          <ArrowLeft className="w-4 h-4" />
        </button>

        <nav className="flex items-center gap-1.5 text-sm" aria-label="Breadcrumb" data-testid="breadcrumb-nav">
          <button
            onClick={handleRootClick}
            className="text-divine-gold/60 hover:text-divine-gold transition-colors"
            data-testid="breadcrumb-root"
          >
            {rootLabel}
          </button>

          <ChevronRight className="w-3.5 h-3.5 text-divine-gold/30" />

          <button
            onClick={handleTabClick}
            className="text-divine-gold/60 hover:text-divine-gold transition-colors"
            data-testid="breadcrumb-tab"
          >
            {tabLabel}
          </button>

          <ChevronRight className="w-3.5 h-3.5 text-divine-gold/30" />

          <span className="text-divine-gold font-medium" data-testid="breadcrumb-entity">
            {entityName || "Loading..."}
          </span>
        </nav>
      </div>
    </div>
  );
};

export default AdminViewBreadcrumb;
